/* eslint-disable react/no-unescaped-entities */
import { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { fetchWrapper } from '../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../_helpers/_methods';

function ResendOTP({ username, counter, handleOTPReset, setCounter }) {
  const { type } = useParams();

  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  const handleResendOTP = async () => {
    try {
      setLoading(true);
      await fetchWrapper.post('/resend-otp/', {
        username: username
      });

      toast.success(intl.formatMessage({ id: 'otp_has_been_sent' }));
      if (type) setCounter(59);

      handleOTPReset();
      setLoading(false);
    } catch (err) {
      ErrorMessageHandler(err);
      handleOTPReset();

      setLoading(false);
    }
  };

  return (
    <Alert variant="info" className="small my-3 ">
      <FormattedMessage id="otp_not_recieved" /> (
      <ResendBtn
        className={`cursor-pointer text-primary ${loading || counter > 0 ? 'disabled' : 'active'}`}
        onClick={() => handleResendOTP()}>
        <FormattedMessage id="registration.resend" />
      </ResendBtn>{' '}
      )
      {counter === 0 ? null : (
        <div>
          <FormattedMessage id="next_otp" /> {counter} <FormattedMessage id="after_seconds" />
        </div>
      )}
    </Alert>
  );
}

export default ResendOTP;

const ResendBtn = styled.span`
  cursor: pointer;
  &.disabled {
    pointer-events: none;
    opacity: 0.5;
    color: #ddd;
  }
`;
